"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var recompose_1 = require("recompose");
var react_router_dom_1 = require("react-router-dom");
var react_redux_1 = require("react-redux");
var sok_ui_1 = require("@caddigital/sok-ui");
var components_1 = require("components");
var NavigateConfirmation_1 = require("components/NavigateConfirmation");
var messageActions = require("@caddigital/sok-reducers/lib/actions/bid/message");
var bidMessageAttachments_1 = require("actions/bidMessageAttachments");
var translation_1 = require("@caddigital/sok-reducers/lib/utils/translation");
var translate_1 = require("utils/translate");
var formatSize_1 = require("utils/helpers/formatSize");
var Types = require("types");
var Tools_1 = require("./Tools");
var UploadModal_1 = require("./UploadModal");
var ParticipantModal_1 = require("./ParticipantModal");
var ValidationModal_1 = require("./ValidationModal");
require("./style.scss");
var mapStateToProps = function (state) {
    var selectedLanguage = (0, translate_1.getLanguage)();
    return {
        currentUser: state.auth.current.user,
        message: state.bid.message,
        uploadSession: state.bidMessageAttachments.currentUploadStatus.session,
        uploadAllDone: state.bidMessageAttachments.currentUploadStatus.allDone,
        selectedLanguage: selectedLanguage
    };
};
var mapDispatchToProps = function (dispatch) { return ({
    setStandby: function () { return dispatch(messageActions.setStandby()); },
    fetch: function (currentBid, messageId) {
        return dispatch(messageActions.fetchRequest(currentBid, messageId));
    },
    updateField: function (field, value) {
        return dispatch(messageActions.updateField(field, value));
    },
    send: function (currentBid, to, subject, message, attachments, session) {
        dispatch(messageActions.sendRequest(currentBid, to, subject, message, attachments, session));
    },
    clear: function () { return (dispatch(messageActions.clear()), dispatch(bidMessageAttachments_1.default.fileuploadDone())); }
}); };
var statePropsExtractable = Types.extractReturnType(mapStateToProps);
var dispatchPropsExtractable = Types.extractReturnType(mapDispatchToProps);
var enhance = (0, recompose_1.compose)((0, recompose_1.setDisplayName)('BidParticipantsTools'), (0, recompose_1.withState)('selected', 'setSelected', []), (0, recompose_1.withState)('participantModal', 'toggleParticipantModal', false), (0, recompose_1.withState)('statusModal', 'toggleStatusModal', false), (0, recompose_1.withState)('validationModal', 'toggleValidationModal', false), (0, react_redux_1.connect)(mapStateToProps, mapDispatchToProps), react_router_dom_1.withRouter, (0, recompose_1.lifecycle)({
    componentDidMount: function () {
        if (this.props.match.params.messageId !== undefined) {
            this.props.fetch(this.props.currentBid, this.props.match.params.messageId);
        }
        else {
            this.props.updateField('from', this.props.currentUser.fold('-', function (u) { return u.email; }));
        }
    },
    componentDidUpdate: function (prevProps) {
        if (prevProps.message.saveStatus === 'STANDBY' &&
            this.props.message.saveStatus !== 'STANDBY' &&
            this.props.message.saveStatus !== 'FAILED') {
            this.props.toggleStatusModal(true);
        }
        if (this.props.message.errors !== prevProps.message.errors &&
            this.props.message.errors.isSome()) {
            this.props.toggleValidationModal(true);
        }
    },
    componentWillUnmount: function () {
        this.props.clear();
    }
}), recompose_1.pure);
exports.default = enhance(function (props) {
    var viewMode = props.match.params.messageId !== undefined;
    var revision = props.message.attachments.filter(function (x) {
        var deleted = props.message.removedAttachemnts.findIndex(function (y) { return y.id === x.id; }) > -1;
        return x.type !== 'FOLDER' && !deleted;
    });
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: 'content-wrapper-content' },
            React.createElement("div", { className: 'bid-create-new-message-view' },
                React.createElement("main", { className: 'content' },
                    React.createElement(sok_ui_1.BreadCrumb, null,
                        React.createElement(react_router_dom_1.Link, { to: "/".concat(props.selectedLanguage, "/briefcase/").concat(props.currentBriefcase.id, "/bids") }, props.currentBriefcase.name),
                        React.createElement("span", null, props.currentBid.name),
                        React.createElement(react_router_dom_1.Link, { to: "/".concat(props.selectedLanguage, "/briefcase/").concat(props.currentBriefcase.id, "/bid/").concat(props.currentBid.id, "/messages") }, (0, translation_1.getLocalization)('breadcrumb/sokobid/messages')),
                        React.createElement("span", null, viewMode
                            ? props.message.subject
                            : (0, translation_1.getLocalization)('breadcrumb/newMessage'))),
                    React.createElement("div", { className: 'tools-row' },
                        React.createElement(sok_ui_1.Button, { size: 'large', color: 'green', text: (0, translation_1.getLocalization)('bid/messageView/send'), disabled: viewMode, onClick: function () {
                                return props.send(props.currentBid, props.message.to, props.message.subject, props.message.message, props.message.attachments.filter(function (x) {
                                    return props.message.removedAttachemnts.findIndex(function (y) { return y.id === x.id; }) === -1;
                                }), props.uploadSession);
                            } }),
                        React.createElement(sok_ui_1.Button, { size: 'large', color: 'dark-gray', text: (0, translation_1.getLocalization)('bid/messageView/close'), onClick: function () {
                                return props.history.push("/".concat(props.selectedLanguage, "/briefcase/").concat(props.currentBriefcase.id, "/bid/").concat(props.currentBid.id, "/messages"));
                            } })),
                    React.createElement(sok_ui_1.Panel, { icon: React.createElement(sok_ui_1.Icon, { className: 'fa-envelope', prefix: 'far' }), disableCollapse: true, title: (0, translation_1.getLocalization)('bid/messageView/title') },
                        React.createElement("div", { className: 'row-item' },
                            React.createElement("label", null,
                                (0, translation_1.getLocalization)('bid/messageView/from'),
                                ":"),
                            React.createElement(sok_ui_1.TextInput, { value: props.message.from, disabled: true })),
                        React.createElement("div", { className: 'row-item recipient' },
                            React.createElement("label", null,
                                (0, translation_1.getLocalization)('bid/messageView/to'),
                                ":",
                                ' ',
                                React.createElement("span", { className: 'normal' },
                                    "(",
                                    (0, translation_1.getLocalization)('bid/messageView/to/bcc'),
                                    ")")),
                            React.createElement(sok_ui_1.TextInput, { editable: !viewMode, type: 'textarea', rows: 2, value: props.message.to, onChange: function (e) { return props.updateField('to', e.target.value); }, iconRight: !viewMode ? (React.createElement(sok_ui_1.Icon, { className: 'fa-plus-circle toggle-participant-modal', onClick: function () {
                                        props.toggleParticipantModal(true);
                                    } })) : undefined })),
                        React.createElement("div", { className: 'row-item' },
                            React.createElement("label", null,
                                (0, translation_1.getLocalization)('bid/messageView/subject'),
                                ":"),
                            React.createElement(sok_ui_1.TextInput, { editable: !viewMode, value: props.message.subject, onChange: function (e) {
                                    props.updateField('subject', e.target.value);
                                } })),
                        props.message.attachmentsStatus === 'FETCHING' && (React.createElement("div", { className: 'row-item' },
                            React.createElement("label", null,
                                (0, translation_1.getLocalization)('bid/messageView/attachments'),
                                ":"),
                            React.createElement("div", { className: 'fetch-attachments fetching' },
                                React.createElement(sok_ui_1.LoadingSpinner, null),
                                React.createElement("div", null, (0, translation_1.getLocalization)('bid/messageView/attachments/fetching'))))),
                        props.message.attachmentsStatus === 'FAILED' && (React.createElement("div", { className: 'row-item' },
                            React.createElement("label", null,
                                (0, translation_1.getLocalization)('bid/messageView/attachments'),
                                ":"),
                            React.createElement("div", { className: 'fetch-attachments failed' },
                                React.createElement("div", null, (0, translation_1.getLocalization)('bid/messageView/attachments/failed'))))),
                        (props.message.attachmentsStatus === 'STANDBY' ||
                            props.message.attachmentsStatus === 'FETCHED') &&
                            revision.length > 0 && (React.createElement("div", { className: 'row-item' },
                            React.createElement("label", null,
                                (0, translation_1.getLocalization)('bid/messageView/attachments'),
                                ":"),
                            React.createElement(sok_ui_1.Grid.Row, { className: 'attachments' }, revision.map(function (x) {
                                var sizeMeta = (x.customMeta || []).find(function (y) { return y.uuid === 'size-meta'; });
                                var selected = props.selected.includes(x);
                                return (React.createElement(sok_ui_1.Grid.Column, { large: 4, medium: 6, className: 'attachment', key: "attachment-".concat(x.id) },
                                    React.createElement("div", null,
                                        React.createElement("div", null,
                                            React.createElement(components_1.TableRowIcon, { className: selected ? 'selected' : '', icon: 'fa-check', circle: true, onClick: function () {
                                                    if (selected) {
                                                        props.setSelected(props.selected.filter(function (y) { return y !== x; }));
                                                        return;
                                                    }
                                                    props.setSelected(props.selected.concat(x));
                                                } })),
                                        React.createElement(sok_ui_1.Tooltip, { content: React.createElement("span", null, x.name) },
                                            React.createElement("div", { className: 'content' }, x.name)),
                                        React.createElement("div", null, sizeMeta &&
                                            (0, formatSize_1.formatSize)(sizeMeta.value)))));
                            })))),
                        React.createElement("div", { className: 'row-item message' },
                            React.createElement("label", null,
                                (0, translation_1.getLocalization)('bid/messageView/message'),
                                ":"),
                            React.createElement(sok_ui_1.TextInput, { editable: !viewMode, type: 'textarea', rows: 12, value: props.message.message, onChange: function (e) {
                                    props.updateField('message', e.target.value);
                                } }))),
                    React.createElement(UploadModal_1.UploadModal, { currentBid: props.currentBid }),
                    React.createElement(sok_ui_1.Modal, { isOpen: props.statusModal, className: 'bid-message-save-status' },
                        React.createElement(sok_ui_1.Header, { onClose: function () {
                                props.toggleStatusModal(false);
                                props.setStandby();
                            } }, (0, translation_1.getLocalization)('bid/messageView/sending/modal/info')),
                        React.createElement("div", { className: 'status-spinner' },
                            React.createElement(sok_ui_1.RequestSpinner, { isLoading: props.message.saveStatus === 'FETCHING', success: props.message.saveStatus === 'FETCHED' }),
                            React.createElement("div", null,
                                React.createElement("h3", null, (0, translation_1.getLocalization)('bid/messageView/sending/modal/title')),
                                React.createElement("div", null, (0, translation_1.getLocalization)((function () {
                                    switch (props.message.saveStatus) {
                                        case 'FETCHED':
                                            return 'bid/messageView/success';
                                        case 'FAILED':
                                            return 'bid/messageView/failed';
                                        default:
                                            return 'bid/messageView/sending';
                                    }
                                })())))),
                        React.createElement(sok_ui_1.Footer, null,
                            React.createElement("div", { className: 'tools' }, props.message.saveStatus === 'FETCHED' && (React.createElement(sok_ui_1.Button, { size: 'large', color: 'green', text: (0, translation_1.getLocalization)('bid/messageView/ready'), onClick: function () {
                                    return props.history.push("/".concat(props.selectedLanguage, "/briefcase/").concat(props.currentBriefcase.id, "/bid/").concat(props.currentBid.id, "/messages"));
                                } }))))),
                    !viewMode && (React.createElement(ParticipantModal_1.ParticipantModal, { currentBid: props.currentBid, participantModal: props.participantModal, toggleParticipantModal: props.toggleParticipantModal, onChange: function (users) {
                            var emails = users
                                .sort(function (a, b) { return a.user.email.localeCompare(b.user.email); })
                                .map(function (x) { return x.user.email; })
                                .join(';');
                            if (props.message.to.trim().length > 0) {
                                props.updateField('to', "".concat(props.message.to, ";").concat(emails));
                            }
                            else {
                                props.updateField('to', emails);
                            }
                        } })),
                    !viewMode && (React.createElement(ValidationModal_1.ValidationModal, { isOpen: props.validationModal, close: function () { return props.toggleValidationModal(false); }, errors: props.message.errors })))),
            React.createElement(NavigateConfirmation_1.default, { display: !viewMode && props.message.saveStatus !== 'FETCHED', header: (0, translation_1.getLocalization)('global/confirmation'), firstRow: (0, translation_1.getLocalization)('bid/message/unsavedChanges'), secondRow: (0, translation_1.getLocalization)('bid/message/areYouSure'), confirmText: (0, translation_1.getLocalization)('buttons/delete') })),
        React.createElement(Tools_1.Tools, { selected: props.selected, setSelected: props.setSelected, viewMode: viewMode, currentBid: props.currentBid, currentBriefcase: props.currentBriefcase })));
});
